import { render, staticRenderFns } from "./DeclarationInformations.vue?vue&type=template&id=70e7a7ad&scoped=true"
import script from "./DeclarationInformations.vue?vue&type=script&lang=js"
export * from "./DeclarationInformations.vue?vue&type=script&lang=js"
import style0 from "./DeclarationInformations.vue?vue&type=style&index=0&id=70e7a7ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e7a7ad",
  null
  
)

export default component.exports